/* global localStorage, URLSearchParams */
import Vue from "vue";
import Router from "vue-router";
import Home from "components/home";
import Account from "components/account";
import store from "../store";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/login");
};

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/account",
      name: "Account",
      component: Account,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/auth",
      name: "Authorization",
      component: () => {
        
        const urlParams = new URLSearchParams(window.location.hash.substr(1));
        const id_token = urlParams.get('id_token');
        const access_token = urlParams.get('access_token');
        
        localStorage.setItem('id_token', id_token);
        localStorage.setItem('access_token', access_token);
        
        window.location = '/';
      }
    },
    {
      path: "/login",
      name: "Log in",
      component: () => {
        window.location = 'https://auth.mail.rocksthe.net/login?redirect_uri=https://mail.rocksthe.net/auth&response_type=token&client_id=5oam25ss336jkr5fglvnf9mbo9'
      }
    }
  ]
});
